import { gql } from "graphql-tag"

const DELETE_COUNTRY = gql`
  mutation deleteCountry($id: ID!) {
    deleteCountry(id: $id) {
      status
    }
  }
`

export default DELETE_COUNTRY
